import { render } from "./IssueDetails.vue?vue&type=template&id=60630c60&scoped=true"
import script from "./IssueDetails.vue?vue&type=script&lang=js"
export * from "./IssueDetails.vue?vue&type=script&lang=js"

import "./IssueDetails.vue?vue&type=style&index=0&id=60630c60&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3337210614/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60630c60"]])

export default __exports__